import apiClient from './client';
import type { DashboardData, Announcement, BudgetDate } from '../types/dashboard';
import {
  decodeAnnouncement,
  decodeDashboardData,
  decodeKeyDate,
} from '../utils/decodeApiStrings';

export async function getDashboard(): Promise<DashboardData> {
  const { data } = await apiClient.get<DashboardData>('/apex/dashboard');
  return decodeDashboardData(data);
}

export async function getAnnouncements(): Promise<Announcement[]> {
  const { data } = await apiClient.get<Announcement[]>('/apex/announcements');
  return data.map(decodeAnnouncement);
}

export async function createAnnouncement(announcement: Partial<Announcement>): Promise<Announcement> {
  const { data } = await apiClient.post<Announcement>('/apex/announcements', announcement);
  return decodeAnnouncement(data);
}

export async function updateAnnouncement(id: number, announcement: Partial<Announcement>): Promise<Announcement> {
  const { data } = await apiClient.put<Announcement>(`/apex/announcements/${id}`, announcement);
  return decodeAnnouncement(data);
}

export async function deleteAnnouncement(id: number): Promise<void> {
  await apiClient.delete(`/apex/announcements/${id}`);
}

export async function getDates(): Promise<BudgetDate[]> {
  const { data } = await apiClient.get<BudgetDate[]>('/apex/dates');
  return data.map(decodeKeyDate);
}

export async function createDate(date: Partial<BudgetDate>): Promise<BudgetDate> {
  const { data } = await apiClient.post<BudgetDate>('/apex/dates', date);
  return decodeKeyDate(data);
}

export async function updateDate(id: number, date: Partial<BudgetDate>): Promise<BudgetDate> {
  const { data } = await apiClient.put<BudgetDate>(`/apex/dates/${id}`, date);
  return decodeKeyDate(data);
}

export async function deleteDate(id: number): Promise<void> {
  await apiClient.delete(`/apex/dates/${id}`);
}

/** Mark an IO Plan @mention as read (clears io_plan_mention on next dashboard load). */
export async function markIoPlanMentionRead(
  commentKind: 'io' | 'line_item',
  sourceId: number,
): Promise<void> {
  await apiClient.post('/apex/mark-io-plan-mention-read', {
    comment_kind: commentKind,
    source_id: sourceId,
  });
}
